import { useMemo } from "react";
import { homeLocation, statusMap } from "../popData";
import { getPrimariesMetadata } from "../helperFunctions/mapHelpers";

function LocationItem({ location, setRoutes, options }) {
  let { marker } = location;
  let markerEl = null;
  if (marker) {
    markerEl = marker.getElement();
  }
  //   let markerEl = marker.getElement();
  let locationLabel =
    location?.authorisedBy ||
    location?.name ||
    String(location?.refNumber) ||
    "---";

  //   console.log("markerEl", markerEl);
  function handleMouseEnter() {
    // let marker1 = markers.find((m) => {
    //   return m.uid === location.uid;
    // });
    if (marker) {
      let mPopup = marker?.getPopup();
      if (mPopup.isOpen() === false) marker.togglePopup();
    }

    // let marker = document.getElementById(location.uid);
    if (markerEl) {
      //   markerEl.style.borderRadius = "0px";
    }
  }

  function handleMouseLeave() {
    // let markerEl = document.getElementById(location.uid);

    // let marker1 = markers.find((m) => {
    //   return m.uid === location.uid;
    // });

    if (marker) {
      let mPopup = marker?.getPopup();
      if (mPopup.isOpen() === true) marker.togglePopup();
    }

    if (markerEl) {
      //   markerEl.style.background =
      //     statusMap[location?.status ?? "no-status"]?.background;
      //   markerEl.style.border = "2px solid darkslategrey";
      //   markerEl.style.borderRadius = "9px";
    }
  }

  return (
    <p
      className="location-list-item"
      onClick={() => {
        setRoutes(location);
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {locationLabel}
    </p>
  );
}

function MapLocationsList({
  metadata,
  locationData,
  setRoutes,
  setOptions,
  options,
  badAddresses,
}) {
  const [home, bookedIn, arrangeDate, provisional, selected] = useMemo(() => {
    let a = locationData.filter((l) => l.status === "home-status");
    let b = locationData.filter((l) => l.status === "booked-in");
    let c = locationData.filter((l) => l.status === "arrange-date");
    let d = locationData.filter((l) => l.status === "provisional");
    let e = locationData.filter((l) => l.status === "selected");

    return [a, b, c, d, e];
  }, [locationData]);

  function handleFilterToggle(value) {
    // Toggle whatever status filter is passed in via value

    setOptions((prevState) => {
      let { statusFilters } = prevState;
      let newFilters = [...statusFilters];

      if (statusFilters.includes(value)) {
        // remove filter
        newFilters = statusFilters.filter((item) => item !== value);
      } else {
        // add filter
        newFilters.push(value);
      }

      return { ...prevState, statusFilters: newFilters };
    });
  }

  let bookedInExist =
    metadata["booked-in"] && metadata["booked-in"]?.length > 0;
  let provisionalExist =
    metadata["provisional"] && metadata["provisional"]?.length > 0;
  let arrangeExist =
    metadata["arrange-date"] && metadata["arrange-date"]?.length > 0;
  let selectedExist = metadata["selected"] && metadata["selected"]?.length > 0;

  return (
    <div className="locations-list">
      <div className="location-list-section">
        {/* <p className="section-title">Home Title</p> */}
        {/* {home.map((location) => {
          return ( */}
        <LocationItem
          options={options}
          key={homeLocation.uid}
          location={homeLocation}
          setRoutes={setRoutes}
        />
        {/* );
        })} */}
      </div>

      {bookedInExist && (
        <div className="location-list-section">
          <button
            onClick={() => handleFilterToggle("booked-in")}
            className={`location-list-title ${
              options.statusFilters.includes("booked-in") ? "" : "filtered-out"
            }`}
          >
            Booked In
          </button>
          {bookedIn.map((location) => {
            return (
              <LocationItem
                options={options}
                key={location.uid}
                location={location}
                setRoutes={setRoutes}
              />
            );
          })}
        </div>
      )}

      {provisionalExist && (
        <div className="location-list-section">
          <button
            onClick={() => handleFilterToggle("provisional")}
            className={`location-list-title ${
              options.statusFilters.includes("provisional")
                ? ""
                : "filtered-out"
            }`}
          >
            Provisional
          </button>
          {provisional.map((location) => {
            return (
              <LocationItem
                options={options}
                key={location.uid}
                location={location}
                setRoutes={setRoutes}
              />
            );
          })}
        </div>
      )}

      {arrangeExist && (
        <div className="location-list-section">
          <button
            onClick={() => handleFilterToggle("arrange-date")}
            className={`location-list-title ${
              options.statusFilters.includes("arrange-date")
                ? ""
                : "filtered-out"
            }`}
          >
            Arrange Date
          </button>
          {arrangeDate.map((location) => {
            return (
              <LocationItem
                options={options}
                key={location.uid}
                location={location}
                setRoutes={setRoutes}
              />
            );
          })}
        </div>
      )}

      {selectedExist && (
        <div className="location-list-section">
          <button
            onClick={() => handleFilterToggle("selected")}
            className={`location-list-title ${
              options.statusFilters.includes("selected") ? "" : "filtered-out"
            }`}
          >
            Selected
          </button>
          {selected.map((location) => {
            return (
              <LocationItem
                options={options}
                key={location.uid}
                location={location}
                setRoutes={setRoutes}
              />
            );
          })}
        </div>
      )}

      {badAddresses.length > 0 && (
        <div className="location-list-section">
          <button
            className={`location-list-title bad-addresses`}
            // onClick={() => handleFilterToggle("selected")}
            // className={`location-list-title ${
            //   options.statusFilters.includes("selected") ? "" : "filtered-out"
            // }`}
          >
            Bad Addresses
          </button>
          {badAddresses.map((location) => {
            return (
              <LocationItem
                options={options}
                key={location.uid}
                location={location}
                setRoutes={() => {}}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

export default MapLocationsList;
